<!-- 订单中费用查询费用凭证 -->
 <template>
    <div> 
        <el-dialog title="费用凭证" :visible.sync="feeVoucherShow" width="80%" :before-close="handleClose"
        :close-on-click-modal="false"  >
          <el-table :data="feeList" style="width: 100%" :header-cell-style="{'text-align':'center'}">
            <el-table-column type="index" width="50" align="center"> </el-table-column>
            <el-table-column prop="billNo" label="单据编号" width="120" align="center">  </el-table-column>
            <el-table-column prop="createMan" label="创建人" width="100" align="center">  </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="150" align="center">  </el-table-column>
            <el-table-column prop="financeStatus" label="付款状态" width="120" align="center">  </el-table-column>
            <el-table-column prop="currency" label="币制"  width="80" align="center">  </el-table-column>
            <el-table-column prop="checkStatus" label="审核状态"  width="80" align="center"> 
                <template slot-scope="scope">
                    {{ getCheckStatusText(scope.row.checkStatus) }}
                </template>    
            </el-table-column>
            <el-table-column prop="company" label="往来单位"  width="180" align="center">  </el-table-column>
            <el-table-column prop="voucherNo" label="发票号"  width="120" align="center">  </el-table-column>
            <el-table-column prop="checkManager" label="审批经理"  width="120" align="center">  </el-table-column>
            <el-table-column prop="comment" label="审批意见"  width="220" align="center">  </el-table-column>
            <el-table-column prop="processTime" label="提交时间"  width="150" align="center">  </el-table-column>
            <el-table-column prop="invoiceInfo" label="开票信息"  width="280" align="center">  </el-table-column>
            <el-table-column prop="note" label="备注"  width="280" align="center" >  </el-table-column>
            </el-table>
        </el-dialog>
    </div> 
</template>
<script>
import req from '@/utils/index.js'
import url1 from '@/config/url2.js'

export default {
    name: 'feeVouchers',
    props: {
        id:{
            type: String,
            default: ''
        }
    },
    watch: {
        id: {
            handler(newVal,oldVal) {
                if(newVal){
                    this.getFeeList()
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        }
    },
    data() {
        return {
            feeVoucherShow:false,
            feeList: [],
        };
    },
    methods: {
        // 查询费用凭证
        getFeeList(){
            let URL = `${url1.getFeeVoucher}/${this.id}`;
            req.get(URL).then(res => {
                if (res.data.data.length !== 0) {
                    this.feeVoucherShow = true
                    this.feeList = res.data.data;
                }else{
                    this.$message({
                        message: '此费用没有费用凭证',
                        type: 'warning'
                    });
                    this.handleClose()
                }
            })
        },
        // 关闭弹窗
        handleClose(){
            this.feeVoucherShow = false
            this.feeList = []
            this.$emit('closeFeeVoucher', false)
        },
        //区别状态
        getCheckStatusText(status) {
            switch (status) {
                case 0:
                    return '新增';
                case 1:
                    return '审核中';
                case 2:
                    return '审核完成';
                case 3:
                    return '驳回';
                default:
                    return '未知状态';
            }
        },
    }
}
</script>
<style lang="css" scoped>

::v-deep .el-table .cell {
    white-space: normal !important; 
    overflow: hidden !important;
    box-sizing: border-box !important;
    text-overflow: ellipsis !important;
    word-break: break-all !important;
    line-height: 23px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
}
</style>